import { useAppDispatch, useAppSelector } from "lib/redux";
import { baseRESTUrl } from "lib/utils";
import { updateMe, refreshMe, selectMe } from ".";
import { useState } from "react";
import { Button } from '@chakra-ui/react';

export const UndoDeleteAccount = () => {
  const me = useAppSelector(selectMe);
  const dispatch = useAppDispatch()
  const [processing, setProcessing] = useState<boolean>(false);
  
  const undo = async () => {
    setProcessing(true);
    await dispatch(updateMe({delete_scheduled: false}));
    await dispatch(refreshMe(baseRESTUrl()));
    setProcessing(false);
  }

  if (!me.user?.delete_scheduled) {
    return null;
  }

  return (  
    <Button
      size="md"
      variant="ghost"
      isFullWidth
      onClick={undo}
      isLoading={processing}
      className="button--unschedule-delete"
    >
      Undo Delete Account
    </Button>
  )
}
